"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Stepper = _interopRequireDefault(require("@material-ui/core/Stepper"));
var _Step = _interopRequireDefault(require("@material-ui/core/Step"));
var _StepLabel = _interopRequireDefault(require("@material-ui/core/StepLabel"));
var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));
var _SttModal = _interopRequireDefault(require("./SttModal"));
var _excluded = ["steps", "activeStep"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    stepper: {
      color: theme.palette.common.white,
      backgroundColor: 'transparent',
      padding: 0,
      '& .MuiStepLabel-root': {
        color: theme.palette.common.white
      },
      '& .MuiStepLabel-label': {
        color: theme.palette.common.white,
        '&.MuiStepLabel-active': {
          color: theme.palette.common.white,
          fontWeight: theme.typography.fontWeightBold
        },
        '&.MuiStepLabel-completed': {
          color: theme.palette.common.white
        }
      },
      '& .MuiStepConnector-line': {
        borderColor: theme.palette.common.white
      }
    },
    stepIcon: {
      width: 24,
      height: 24,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightMedium,
      lineHeight: 1,
      border: "1px solid ".concat(theme.palette.common.white),
      backgroundColor: 'transparent',
      color: theme.palette.common.white
    },
    stepIconActive: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.primary.main,
      borderColor: theme.palette.common.white
    },
    stepIconCompleted: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.primary.main,
      borderColor: theme.palette.common.white
    },
    stepIconCheck: {
      fontSize: 16
    }
  };
});
function SttStepIcon(props) {
  var classes = useStyles();
  var active = props.active,
    completed = props.completed,
    icon = props.icon;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.stepIcon, " ").concat(active ? classes.stepIconActive : '', " ").concat(completed ? classes.stepIconCompleted : '')
  }, completed ? /*#__PURE__*/_react["default"].createElement(_Check["default"], {
    className: classes.stepIconCheck
  }) : icon);
}
SttModalStepper.propTypes = {
  title: _propTypes["default"].string,
  children: _propTypes["default"].node,
  footer: _propTypes["default"].node,
  outModalClose: _propTypes["default"].func,
  iconClose: _propTypes["default"].func,
  open: _propTypes["default"].bool.isRequired,
  contentDividers: _propTypes["default"].bool,
  steps: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  activeStep: _propTypes["default"].number.isRequired
};
SttModalStepper.defaultProps = {
  open: false,
  contentDividers: false
};
function SttModalStepper(props) {
  var classes = useStyles();
  var steps = props.steps,
    activeStep = props.activeStep,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_SttModal["default"], _extends({}, other, {
    headerExtra: /*#__PURE__*/_react["default"].createElement(_Stepper["default"], {
      activeStep: activeStep,
      className: classes.stepper
    }, steps.map(function (label) {
      return /*#__PURE__*/_react["default"].createElement(_Step["default"], {
        key: label
      }, /*#__PURE__*/_react["default"].createElement(_StepLabel["default"], {
        StepIconComponent: SttStepIcon
      }, label));
    }))
  }));
}
var _default = SttModalStepper;
exports["default"] = _default;